import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet, redirect } from "@tanstack/react-router";
import { TooltipProvider } from "@vd/ui";
import { Toaster } from "../components/toast";
import { redirectFor } from "../lib/redirects";

export interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  // Old console addresses (bookmarks, CRM notes, emails) move to their Admin mode homes once.
  beforeLoad: ({ location }) => {
    const to = redirectFor(location.pathname, location.searchStr, location.hash);
    if (to) throw redirect({ href: to, replace: true });
  },
  component: () => (
    <TooltipProvider>
      <Outlet />
      <Toaster />
    </TooltipProvider>
  ),
  notFoundComponent: () => (
    <div className="flex h-full items-center justify-center p-8 text-center">
      <div>
        <p className="text-body font-medium">This page doesn't exist.</p>
        <a href="/" className="mt-2 inline-block text-body text-accent-ink hover:underline">
          Go to the console
        </a>
      </div>
    </div>
  ),
});
